import React,{useState,useEffect} from "react";
import CustomHeading from '../../../constants/CustomHeading'
import {  Formik, Form} from 'formik';
import * as Yup from 'yup';
import CustomInput from '../../../constants/CustomInput';
import CustomDropdown from '../../../constants/CustomDropdown';
import CustomButton from "../../../constants/CustomButton";
import CustomTableWithAll from '../../../constants/CustomTableWithAll';
import {connect} from 'react-redux';
import {getFacultyWorkloadData,setFacultyWorkloadData} from '../../../redux/actions/dataAction';
import CustomLine from "../../../constants/CustomLine";

const validationSchema = Yup.object().shape({
  department: Yup.string()
  .required('Required'),
  program_type: Yup.string()
  .required('Required'),
  program: Yup.string()
  .required('Required'),
  program_category: Yup.string()
  .required('Required'),
  workload_distribution: Yup.string()
  .required('Required'),
  academic_year: Yup.date()
  .required('Required'),
  type_of_work: Yup.string()
  .required('Required'),

});
const FacultyWorkLoad = (props) => {
  const [isLoading,setIsLoading]=useState(false);
    useEffect(()=>{
        props.getFacultyWorkloadData();
    },[isLoading])
    const columns = [ 
        {title:'department',field:'department'},
        {title:'Program Type',field:'program_type' },
        {title:'Program',field:'program'},
        {title:'Program Category',field:'program_category'},
        {title:'Work Field',field:'work_field'},
        {title:'WorkLoad distribution',field:'workload_distribution'},
        {title:'WorkLoad(%)',field:'workload_percent'},
        {title:'WorkLoad(Hr.)',field:'workload_hr'},

      ]
  return (
    <div className="customContainer">
      <CustomHeading title="Faculty Workload"/>
      <CustomTableWithAll data={props?.Faculty_workload?.data}  columns={columns} api="/api/faculty-workload/"  title={'All Faculty workload'} />
        <CustomLine/>
      <Formik
        initialValues={{
            department: "",
            program_type: "",
            program: "",
            program_category: "",
            workload_distribution: "",
            academic_year: "",
            type_of_work: "",
            work_field: "",
            workload_percent: "",
            workload_hr: "",
            created_by: "admin@test.com"
        }}
        validationSchema={validationSchema}
        onSubmit={values=>{
          console.log(values);
          props.setFacultyWorkloadData(values);
          setIsLoading(true)
        }}
        >
          {({ errors, touched,handleChange,handleSubmit,setFieldValue,values }) => (
            <Form onSubmit={handleSubmit} style={{marginTop:0}}>
              <div className="row">
                <div className="col-md-6">
                  <CustomDropdown
                    label="Department :"
                    data={[{value:"Applied Science and Humanities"},{value:"Civil Engineering"},{value:"Computer Science and Engineering"},{value:"Electrical and Electronics Engineering"},{value:"Electronics and Communication Engineering"},{value:"Information Technology"},{value:"Master of Business Administration"},{value:"Master of Computer Applications"},{value:"Mechanical Engineering "}]}
                    onChange={handleChange('department')}
                    errorText={
                      errors.department && touched.department ? errors.department:null
                    }
                    />
                </div>
                <div className="col-md-6">
                <CustomDropdown
                    label="Program Type :"
                    data={[{value:"Undergraduate"}]}
                    onChange={handleChange('program_type')}
                    errorText={
                      errors.program_type && touched.program_type ? errors.program_type:null
                    }
                    />
                </div>
              </div>

              <div className="row">
                <div className="col-md-6">
                <CustomInput
                        type={'text'}
                        placeholder={'Other Program'}
                        label={'Program Category :'}
                        onChange={handleChange('program_category')}
                        errorText={
                            errors.program_category && touched.program_category ?errors.program_category :null
                        }
                    />
                </div>
                <div className="col-md-6">
                <CustomDropdown
                    label="Program :"
                    data={[{value:"Bachelor Of Technology"}]}
                    onChange={handleChange('program')}
                    errorText={
                      errors.program && touched.program ? errors.program:null
                    }
                    />
                </div>
              </div>

              <div className="row">
                <div className="col-md-6">
                <CustomInput
                type={'date'}
                placeholder={'Select Year'}
                label={'Academic Year :'}
                onChange={handleChange('academic_year')}
                errorText={
                  errors.academic_year && touched.academic_year ? errors.academic_year:null
                }
                />
                </div>
                <div className="col-md-6">
                <CustomDropdown
                    label="Workload Distribution (Semester-Wise) :"
                    data={[{value:"1 - Semester"},{value:"2 - Semester"}]}
                    onChange={handleChange('workload_distribution')}
                    errorText={
                      errors.workload_distribution && touched.workload_distribution ? errors.workload_distribution:null
                    }
                    />
                </div>
              </div>

              <div className="row">
                <div className="col-md-6">
                <CustomInput
                  type={'number'}
                  placeholder={'Workload(%)'}
                  label={'Workload(%) :'}
                  onChange={handleChange('workload_percent')}
                  />
                </div>
                <div className="col-md-6">
                <CustomDropdown
                    label="Type Of Work :"
                    data={[{value:"Theory teaching"},{value:"Laboratory work"},{value:"Project Mentoring"},{value:"Others (specify)"}]}
                    onChange={handleChange('type_of_work')}
                    errorText={
                      errors.type_of_work && touched.type_of_work ? errors.type_of_work:null
                    }
                    />
                </div>
              </div>

              <div className="row">
                <div className="col-md-6">
                <CustomInput
                  type={'number'}
                  placeholder={'Workload(Hrs)'}
                  label={'Workload(Hrs) :'}
                  onChange={handleChange('workload_hr')}
                  />
                </div>
                <div className="col-md-6">
                    {values.type_of_work==="Others (specify)"?
                    <CustomInput
                      type={'text'}
                      label={'Work Field (For above) :'}
                      onChange={handleChange('work_field')}
                      />:null}
                </div>
              </div>
              <CustomButton type="submit" label="Save" />
            </Form>
          )}

        </Formik>
    </div>
  );
};

const mapActionWithProps = {
  getFacultyWorkloadData,
  setFacultyWorkloadData,
}

const mapStateWithProps = (state)=>(
  {
    Faculty_workload:state.data.Faculty_workload
  }
)
export default connect(mapStateWithProps,mapActionWithProps)(FacultyWorkLoad);
